/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:06]
Permissions to update outside the main branch: [false]
*/

import { useLocalStorage } from '@finbeat/react-toolkit';
import { initialAuth } from 'hooks/useAuth';
import { Auth } from 'models/auth';
import { createContext, Dispatch, SetStateAction } from 'react';

type AuthContextType = {
    auth?: Auth;
    setAuth: Dispatch<SetStateAction<Auth | undefined>>;
    hasRole: (role: string | string[]) => boolean;
    isTokenValid: () => boolean;
};

const AuthContext = createContext<AuthContextType>({} as AuthContextType);

const SESSION_STORAGE_AUTH = 'PAYLATER_ADMIN_AUTH';

export const AuthProvider = ({ children }: React.PropsWithChildren) => {
    const [auth, setAuth] = useLocalStorage<Auth>(SESSION_STORAGE_AUTH, initialAuth);
    const isTokenValid = () => {
        if (auth?.accessTokenExpires) {
            return Date.now() <= Date.parse(auth.accessTokenExpires);
        }
        return false;
    };

    const hasRole = (role: string | string[]): boolean => {
        if (auth == null) {
            return false;
        }
        if (auth.roles == null) {
            return false;
        }
        if (typeof role === 'string') {
            return auth.roles.includes(role);
        }
        return auth.roles.some((i) => role.includes(i));
    };

    return (
        <AuthContext.Provider value={{ auth, setAuth, hasRole, isTokenValid }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
